
'format es6';

import $ from 'jquery';
import gsap from 'greensock';
import Promise from 'Promise';
import { factory as sectionFactory } from './Section';

require('../../views-compiled/profile.domain');

const EASING = gsap.Expo;

function ProfileDomain() {
	this.templateName = 'profile.domain.htm';

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	let data;
	this.setData = (vals) => {
		data = vals;
	};

	this.init = () => Promise.resolve(data);

	this.onClickNext = (callback) => {
		const loadQuizBtn = $('[data-next]', this.sectionNode);
		loadQuizBtn.on('click.cursus', callback);
	};

	this.activate = () => {
		dataLayer.push({
			'event': 'customEvent',
			'eventCategory': 'Cursus',
			'eventAction': 'domaine',
			'eventLabel': data.nom
		});
	};

	return this;
}


export function factory(instance) {
	return ProfileDomain.call(sectionFactory(instance || {}));
}
